"use client";

import { useState } from "react";
import { Send, X } from "lucide-react";

const FloatingWhatsApp = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");

  const phoneNumber = "8801723689712";

  // Messages in Bangla (Questions & Options)
  const quickQuestions = [
    "ডেলিভারি চার্জ কত?",
    "অর্ডার কিভাবে করব?",
    "পেমেন্ট মেথড কি কি আছে?",
  ];

  const handleSendMessage = (textToSend?: string) => {
    const text = textToSend || message;
    if (!text.trim()) return;

    const encodedMessage = encodeURIComponent(text);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");

    setMessage("");
    setIsOpen(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "110px",
        right: "20px",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
      }}
    >
      {/* =====================================================
          CHATBOX WINDOW POPUP
      ===================================================== */}
      {isOpen && (
        <div
          style={{
            width: "320px",
            maxWidth: "calc(100vw - 40px)",
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 12px 30px rgba(0, 0, 0, 0.2)",
            overflow: "hidden",
            marginBottom: "16px",
            border: "1px solid #e5e7eb",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            style={{
              background: "#075E54",
              color: "#ffffff",
              padding: "14px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div
                style={{
                  width: "38px",
                  height: "38px",
                  borderRadius: "50%",
                  background: "#25D366",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "700",
                  fontSize: "16px",
                }}
              >
                iM
              </div>
              <div>
                <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "700" }}>
                  iMall Support
                </h4>
                <span
                  style={{
                    fontSize: "11px",
                    color: "#25D366",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <span
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      background: "#25D366",
                      display: "inline-block",
                    }}
                  />
                  Typically replies instantly
                </span>
              </div>
            </div>

            <button
              type="button"
              onClick={() => setIsOpen(false)}
              aria-label="Close Chat"
              style={{
                background: "transparent",
                border: "none",
                color: "#ffffff",
                cursor: "pointer",
                padding: "4px",
              }}
            >
              <X size={18} />
            </button>
          </div>

          {/* Chat Body */}
          <div
            style={{
              padding: "16px",
              background: "#efeae2",
              minHeight: "180px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {/* Auto Bot Welcome Message (In Bangla) */}
            <div
              style={{
                background: "#ffffff",
                padding: "10px 12px",
                borderRadius: "0px 12px 12px 12px",
                maxWidth: "85%",
                fontSize: "13px",
                color: "#111827",
                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                lineHeight: "1.4",
              }}
            >
              আসসালামু আলাইকুম! <br />
              আপনাকে কীভাবে সাহায্য করতে পারি?
            </div>

            {/* Quick Question Buttons */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                marginTop: "6px",
              }}
            >
              <span
                style={{
                  fontSize: "11px",
                  color: "#6b7280",
                  fontWeight: "600",
                }}
              >
                Quick Questions:
              </span>
              {quickQuestions.map((q, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() => handleSendMessage(q)}
                  style={{
                    background: "#ffffff",
                    border: "1px solid #cbd5e1",
                    borderRadius: "16px",
                    padding: "6px 12px",
                    fontSize: "12px",
                    color: "#075E54",
                    textAlign: "left",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                >
                  {q}
                </button>
              ))}
            </div>
          </div>

          {/* Input Box */}
          <div
            style={{
              padding: "10px",
              background: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <input
              type="text"
              placeholder="Type a message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
              style={{
                flex: 1,
                border: "1px solid #d1d5db",
                borderRadius: "20px",
                padding: "8px 14px",
                fontSize: "13px",
                outline: "none",
              }}
            />
            <button
              type="button"
              onClick={() => handleSendMessage()}
              aria-label="Send Message"
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                background: "#128C7E",
                color: "#ffffff",
                border: "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Send size={16} />
            </button>
          </div>
        </div>
      )}

      {/* =====================================================
          FLOATING BUTTON
      ===================================================== */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="WhatsApp Chat"
        style={{
          width: "52px",
          height: "52px",
          borderRadius: "50%",
          background: "#25D366",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.25)",
          padding: 0,
        }}
      >
        {isOpen ? (
          <X size={26} color="#ffffff" />
        ) : (
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.403 5.592A8.934 8.934 0 0 0 12.052 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.125 1.2 4.488L3 21l4.604-1.208a8.947 8.947 0 0 0 4.444 1.185h.004c4.947 0 8.976-4.027 8.978-8.977 0-2.398-.934-4.653-2.627-6.408zm-6.351 13.812h-.003a7.443 7.443 0 0 1-3.798-1.042l-.272-.162-2.824.741.754-2.753-.177-.282a7.447 7.447 0 0 1-1.141-3.929c.002-4.116 3.352-7.465 7.47-7.465 1.993 0 3.866.778 5.275 2.188 1.408 1.41 2.184 3.284 2.182 5.278-.002 4.117-3.352 7.466-7.466 7.466zm4.095-5.583c-.225-.112-1.332-.657-1.539-.733-.206-.075-.356-.112-.506.112-.15.225-.58.733-.711.883-.131.15-.262.169-.487.056-.225-.113-.95-.35-1.81-1.118-.67-.599-1.121-1.338-1.252-1.563-.131-.225-.014-.347.098-.459.101-.101.225-.262.337-.393.113-.131.15-.225.225-.375.075-.15.038-.281-.019-.393-.056-.113-.506-1.218-.693-1.668-.182-.439-.367-.379-.506-.386-.131-.007-.281-.007-.431-.007-.15 0-.394.056-.6.281-.206.225-.787.769-.787 1.875 0 1.106.806 2.174.918 2.324.113.15 1.587 2.423 3.845 3.398.537.232.956.371 1.283.475.54.171 1.031.147 1.419.089.432-.065 1.332-.544 1.519-1.068.187-.525.187-.975.131-1.068-.056-.094-.206-.15-.431-.262z"
              fill="#ffffff"
            />
          </svg>
        )}
      </button>
    </div>
  );
};

export default FloatingWhatsApp;